import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-mdl-modify-task',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './mdl-modify-task.html',
  styleUrls: ['./mdl-modify-task.css'],
})
export class MDLModifyTask implements OnInit {
  ejecutivos: any[] = [];
  relacionados: any[] = [];
  tipoRelacionado: string = '';
  elementosFiltrados: any[] = [];
  showRepeatOptions: boolean = false;
  showReminderOptions: boolean = false;
  dummyFrecuencia: string = '';
  dummyFechaInicio: string = this.getTodayDate();
  dummyFechaFin: string = this.getTodayDate();
  dummyHoraInicio: string = '10:00';
  dummyHoraFin: string = '10:00';
  dummyTiempoRecordatorio: string = '';

  tiposTarea = [
    { valor: 'Tarea', nombre: 'Tarea' },
    { valor: 'Llamada', nombre: 'Llamada' },
    { valor: 'Evento', nombre: 'Evento' },
    { valor: 'Email', nombre: 'Email' },
  ];

  estadosTarea = [
    { valor: 'Pendiente', nombre: 'Pendiente' },
    { valor: 'En progreso', nombre: 'En progreso' },
    { valor: 'Completada', nombre: 'Completada' },
    { valor: 'Vencida', nombre: 'Vencida' },
  ];

  prioridades = [
    { valor: 'Baja', nombre: 'Baja' },
    { valor: 'Media', nombre: 'Media' },
    { valor: 'Alta', nombre: 'Alta' },
  ];

  isLoading: boolean = false;
  private alertService = inject(AlertService);
  
  taskData = {
    titulo: '',
    comentarios: '',
    estado: '',
    tipo: '',
    ejecutivo_id: '',
    fecha_vencimiento: this.getTodayDate(),
    hora_vencimiento: '10:00',
    prioridad: '',
    asociado_id: '',
    asociado_tipo: 'OTRO',
  };

  constructor(
    private api: Api,
    public dialogRef: MatDialogRef<MDLModifyTask>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.cargarEjecutivos();
    this.cargarRelacionados();

    if (this.data && this.data.existingTask) {
      this.loadExistingData(this.data.existingTask);
    }
  }

  cargarEjecutivos() {
    this.api.getUsers().subscribe({
      next: (response: any) => {
        console.log('🔍 Respuesta completa del backend:', response);

        let usuarios = [];

        if (Array.isArray(response)) {
          usuarios = response;
        } else if (response.users && Array.isArray(response.users)) {
          usuarios = response.users;
        } else if (response.usuarios && Array.isArray(response.usuarios)) {
          usuarios = response.usuarios;
        } else if (response.message && Array.isArray(response.data)) {
          usuarios = response.data;
        } else {
          console.warn('Estructura de respuesta no reconocida:', response);
          usuarios = [];
        }

        console.log('👥 Usuarios extraídos:', usuarios);

        this.ejecutivos = usuarios
          .filter(
            (usuario: any) =>
              usuario.activo === 1 || usuario.activo === undefined
          )
          .map((usuario: any) => ({
            valor: usuario.usuario_id || usuario.id,
            nombre: `${usuario.nombre} ${usuario.apellido}`,
          }));

        console.log(
          '✅ Usuarios procesados para el dropdown:',
          this.ejecutivos
        );

        if (this.data?.existingTask?.ejecutivo_id && this.ejecutivos.length > 0) {
          const ejecutivoExistente = this.ejecutivos.find(
            e => e.valor === this.data.existingTask.ejecutivo_id
          );
          
          if (!ejecutivoExistente) {
            console.warn('⚠️ Ejecutivo no encontrado en la lista, usando primer usuario disponible');
            this.taskData.ejecutivo_id = this.ejecutivos[0].valor;
          }
        } else if (this.ejecutivos.length > 0 && !this.taskData.ejecutivo_id) {
          this.taskData.ejecutivo_id = this.ejecutivos[0].valor;
          console.log(
            '🎯 Usuario por defecto asignado:',
            this.taskData.ejecutivo_id
          );
        }

        if (this.ejecutivos.length === 0) {
          console.warn('⚠️ No se encontraron usuarios activos');
          this.usarUsuariosDePrueba();
        }
      },
      error: (error) => {
        console.error('❌ Error al cargar usuarios:', error);
        this.usarUsuariosDePrueba();
      },
    });
  }

  usarUsuariosDePrueba() {
    console.log('🔄 Usando usuarios de prueba');
    this.ejecutivos = [
      {
        valor: 'usuario_1',
        nombre: 'Sebastián Pérez',
      },
      {
        valor: 'usuario_2',
        nombre: 'María González',
      },
      {
        valor: 'usuario_3',
        nombre: 'Carlos Rodríguez',
      },
    ];

    if (this.ejecutivos.length > 0 && !this.taskData.ejecutivo_id) {
      this.taskData.ejecutivo_id = this.ejecutivos[0].valor;
    }
  }

  cargarRelacionados() {
    this.api.getContacts().subscribe({
      next: (contacts: any) => {
        const contactosItems = contacts.map((contact: any) => ({
          valor: contact.contacto_id,
          nombre: `Contacto - ${contact.nombre} ${contact.apellido}`,
          tipo: 'CNT',
          icono: 'assets/svg/contact-icon.svg',
        }));

        this.api.getAccounts().subscribe({
          next: (accounts: any) => {
            const cuentasItems = accounts.map((account: any) => ({
              valor: account.cuenta_id,
              nombre: `Cuenta - ${account.nombre_empresa}`,
              tipo: 'ACC',
              icono: 'assets/svg/account-icon.svg',
            }));

            this.api.getOpportunities().subscribe({
              next: (opportunities: any) => {
                const oportunidadesItems = opportunities.map((opp: any) => ({
                  valor: opp.oportunidad_id,
                  nombre: `Oportunidad - ${opp.nombre}`,
                  tipo: 'OPP',
                  icono: 'assets/svg/opportunities-icon.svg',
                }));

                this.relacionados = [
                  ...contactosItems,
                  ...cuentasItems,
                  ...oportunidadesItems,
                  {
                    valor: '',
                    nombre: 'Sin relación específica',
                    tipo: 'OTRO',
                    icono: 'assets/svg/task-icon-orange.svg',
                  },
                ];
              },
              error: (error) => {
                console.error('Error cargando oportunidades:', error);
                this.setRelacionadosDefault();
              },
            });
          },
          error: (error) => {
            console.error('Error cargando cuentas:', error);
            this.setRelacionadosDefault();
          },
        });
      },
      error: (error) => {
        console.error('Error cargando contactos:', error);
        this.setRelacionadosDefault();
      },
    });
  }

  setRelacionadosDefault() {
    this.relacionados = [
      {
        valor: '',
        nombre: 'Sin relación específica',
        tipo: 'OTRO',
        icono: 'assets/svg/task-icon-orange.svg',
      },
    ];
  }

  getTodayDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  closeMdl() {
    this.dialogRef.close(false);
  }

  loadExistingData(existingTask: any) {
    console.log('Cargando datos existentes de tarea:', existingTask);

    this.taskData = {
      titulo: existingTask.titulo || '',
      comentarios: existingTask.comentarios || '',
      estado: existingTask.estado || '',
      tipo: existingTask.tipo || 'Tarea',
      ejecutivo_id:
        existingTask.ejecutivo_id || existingTask.ejecutivo?.usuario_id || '',
      fecha_vencimiento: existingTask.fecha_vencimiento
        ? new Date(existingTask.fecha_vencimiento).toISOString().split('T')[0]
        : this.getTodayDate(),
      hora_vencimiento: existingTask.hora_vencimiento || '10:00',
      prioridad: existingTask.prioridad || 'Media',
      asociado_id: existingTask.asociado_id || '',
      asociado_tipo: existingTask.asociado_tipo || 'OTRO',
    };

    if (existingTask.asociado_tipo && existingTask.asociado_tipo !== 'OTRO') {
      this.tipoRelacionado = existingTask.asociado_tipo;
      this.taskData.asociado_tipo = existingTask.asociado_tipo;

      setTimeout(() => {
        this.cargarElementosPorTipo(this.tipoRelacionado);

        setTimeout(() => {
          if (this.taskData.asociado_id && this.elementosFiltrados.length > 0) {
            const elementoEncontrado = this.elementosFiltrados.find(
              (el) => el.valor === this.taskData.asociado_id
            );
            if (elementoEncontrado) {
              console.log(
                'Elemento relacionado encontrado:',
                elementoEncontrado
              );
            } else {
              console.warn('Elemento relacionado no encontrado en la lista');
            }
          }
        }, 500);
      }, 300);
    }

    console.log('Datos de tarea cargados:', this.taskData);
  }

  onRelacionadoChange(relacionado: any) {
    console.log('Relacionado seleccionado:', relacionado);

    if (relacionado) {
      this.taskData.asociado_id = relacionado.valor;
      this.taskData.asociado_tipo = relacionado.tipo;
    } else {
      this.taskData.asociado_id = '';
      this.taskData.asociado_tipo = 'OTRO';
    }

    console.log('Datos actualizados:', this.taskData);
  }

  modificarTarea() {
    if (!this.taskData.titulo || this.taskData.titulo.trim() === '') {
      alert('Por favor ingresa un título para la tarea');
      return;
    }

    if (!this.taskData.estado) {
      alert('Por favor selecciona el estado de la tarea');
      return;
    }

    if (!this.taskData.tipo) {
      alert('Por favor selecciona el tipo de tarea');
      return;
    }

    if (!this.taskData.ejecutivo_id) {
      alert('Por favor selecciona a quién asignar la tarea');
      return;
    }

    if (!this.taskData.fecha_vencimiento) {
      alert('Por favor selecciona una fecha de vencimiento');
      return;
    }

    if (!this.taskData.prioridad) {
      alert('Por favor selecciona una prioridad');
      return;
    }

    this.isLoading = true;

    const tareaData = {
      tarea_id: this.data?.existingTask?.tarea_id,
      titulo: this.taskData.titulo.trim(),
      comentarios: this.taskData.comentarios.trim(),
      estado: this.taskData.estado,
      tipo: this.taskData.tipo,
      ejecutivo_id: this.taskData.ejecutivo_id,
      fecha_vencimiento: this.taskData.fecha_vencimiento,
      hora_vencimiento: this.taskData.hora_vencimiento,
      prioridad: this.taskData.prioridad,
      asociado_id: this.taskData.asociado_id || null,
      asociado_tipo: this.taskData.asociado_tipo,
    };

    console.log('Enviando datos para modificar tarea:', tareaData);

    this.api.updateTarea(tareaData).subscribe({
      next: (response: any) => {
        console.log('Tarea modificada exitosamente:', response);
        this.isLoading = false;

        this.dialogRef.close({
          success: true,
          tarea: response.tarea || response,
        });
      },
      error: (error) => {
        console.error('Error modificando tarea:', error);
        this.isLoading = false;

        let errorMessage =
          'Error al modificar la tarea. Por favor intenta nuevamente.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.status === 400) {
          errorMessage = 'Error: Datos inválidos enviados al servidor.';
        } else if (error.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para modificar tareas')
        }

        alert(errorMessage);
      },
    });
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  getIconForTipoRelacionado(tipo: string): string {
    const iconos: { [key: string]: string } = {
      CNT: 'assets/svg/contact-icon.svg',
      ACC: 'assets/svg/account-icon.svg',
      OPP: 'assets/svg/opportunities-icon.svg',
    };
    return iconos[tipo] || 'assets/svg/search.svg';
  }

  getPlaceholderPorTipo(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'Selecciona un contacto...';
      case 'ACC':
        return 'Selecciona una cuenta...';
      case 'OPP':
        return 'Selecciona una oportunidad...';
      default:
        return 'Buscar...';
    }
  }

  getTipoDisplay(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'contactos';
      case 'ACC':
        return 'cuentas';
      case 'OPP':
        return 'oportunidades';
      default:
        return 'elementos';
    }
  }

  onTipoRelacionadoChange() {
    console.log('Tipo de relación seleccionado:', this.tipoRelacionado);

    this.taskData.asociado_tipo = this.tipoRelacionado;
    this.taskData.asociado_id = '';
    this.elementosFiltrados = [];

    if (this.tipoRelacionado && this.tipoRelacionado !== 'OTRO') {
      this.cargarElementosPorTipo(this.tipoRelacionado);
    } else {
      this.elementosFiltrados = [];
    }
  }

  cargarElementosPorTipo(tipo: string) {
    console.log('Cargando elementos para tipo:', tipo);

    switch (tipo) {
      case 'CNT':
        this.cargarContactos();
        break;
      case 'ACC':
        this.cargarCuentas();
        break;
      case 'OPP':
        this.cargarOportunidades();
        break;
      default:
        this.elementosFiltrados = [];
    }
  }

  cargarContactos() {
    this.api.getContacts().subscribe({
      next: (response: any) => {
        console.log('Contactos cargados:', response);

        const contactos = response.contactos || response || [];

        this.elementosFiltrados = contactos.map((contacto: any) => ({
          valor: contacto.contacto_id,
          nombre: `${contacto.nombre} ${contacto.apellido}`,
          tipo: 'CNT',
          icono: 'assets/svg/contact-icon.svg',
          tipoDisplay: 'Contacto',
        }));

        console.log(
          'Contactos listos para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('Error al cargar contactos:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarCuentas() {
    this.api.getAccounts().subscribe({
      next: (response: any) => {
        console.log('Cuentas cargadas:', response);

        const cuentas = response.cuentas || response || [];

        this.elementosFiltrados = cuentas.map((cuenta: any) => ({
          valor: cuenta.cuenta_id,
          nombre: cuenta.nombre_empresa,
          tipo: 'ACC',
          icono: 'assets/svg/account-icon.svg',
          tipoDisplay: 'Cuenta',
        }));

        console.log(
          'Cuentas listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('Error al cargar cuentas:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarOportunidades() {
    this.api.getOpportunities().subscribe({
      next: (response: any) => {
        console.log('Oportunidades cargadas:', response);

        const oportunidades = response.oportunidades || response || [];

        this.elementosFiltrados = oportunidades.map((opp: any) => ({
          valor: opp.oportunidad_id,
          nombre: opp.nombre,
          tipo: 'OPP',
          icono: 'assets/svg/opportunities-icon.svg',
          tipoDisplay: 'Oportunidad',
        }));

        console.log(
          'Oportunidades listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('Error al cargar oportunidades:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  limpiarSeleccionRelacionado() {
    this.tipoRelacionado = '';
    this.taskData.asociado_tipo = 'OTRO';
    this.taskData.asociado_id = '';
    this.elementosFiltrados = [];
    console.log('Selección de relación limpiada');
  }
}